import React from 'react';
import { TextArea, Dropdown } from 'semantic-ui-react'

import { getText } from '../../helpers';

export default function PlansComparisonMenu(props) {
  return (
    <div className="plans-comparison-menu">
      <div className="filter-by-plan-dropdown">
        <label>{getText("Select Plans to Compare")}: </label>
        <Dropdown
          id="filter-by-plan-dropdown"
          placeholder={getText("Select Plans to Compare")}
          options={props.planDropdownOptions}
          value={props.selectedPlanIds}
          onChange={props.onPlanDropdownChange}
          fluid
          multiple
          search
          selection
          closeOnBlur
          closeOnChange
        />
      </div>
      <div className="search-risks-input">
        <label>{getText("Search Risks")}: </label>
        <TextArea
          icon='search'
          placeholder={`${getText("Search Risks")}...`}
          value={props.searchTerm}
          onChange={props.onSearchChange}
        />
      </div>
      <div className="filter-by-risks-tags-dropdown">
        <label>{getText("Filter by Risk Tags")}: </label>
        <Dropdown
          id="filter-by-risks-tags-dropdown"
          placeholder={getText("Filter by Risk Tags")}
          options={props.riskTagsOptions}
          value={props.selectedRiskTags}
          onChange={props.onRiskTagsChange}
          fluid
          multiple
          search
          selection
          closeOnBlur
          closeOnChange
        />
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/views/plans_comparison/plans_comparison_menu.js